import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutBottomFull: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-bottom-full, grid, window"><path d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V13.5L3 13.5V3.75Z" fill="currentColor"/><path d="M3 15V20.25C3 20.6642 3.33579 21 3.75 21H20.25C20.6642 21 21 20.6642 21 20.25V15L3 15Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutBottomFull;
